import {
  NotificationConfig, NotificationType,
} from '@routific/hive';
import i18n from '../../i18n';
import { buildTimeWindowShorterThanDurationMessage } from './schedule';

export const buildOutputMessage = (output?: any) => {
  if (!output?.details) {
    return i18n.t('notifications:optimizationSuccess.notification.defaultMessage');
  }

  const {
    unscheduledOrdersCount = 0,
    newScheduledOrdersCount = 0,
    scheduledOrdersCount = 0,
    unscheduledDueToTimeWindowShorterThanDuration = 0,
  } = output.details;

  // newScheduledOrdersCount is used by Move Orders to Routes to display
  // the number of new orders that were scheduled
  // scheduledOrdersCount is used by Optimize Orders to Target Routes to display
  // the number of orders that were scheduled

  const actualScheduledCount = scheduledOrdersCount || newScheduledOrdersCount || 0;
  const totalOrdersCount = actualScheduledCount + unscheduledOrdersCount;

  let message;
  if (unscheduledOrdersCount > 0) {
    message = i18n.t('notifications:optimizationSuccess.notification.scheduledWithTotal', {
      scheduled: actualScheduledCount,
      total: totalOrdersCount,
    });
  } else {
    message = i18n.t('notifications:optimizationSuccess.notification.scheduled', {
      count: actualScheduledCount,
    });
  }

  return message + buildTimeWindowShorterThanDurationMessage(unscheduledDueToTimeWindowShorterThanDuration);
};

export const buildMoveOrdersToRoutesSuccessNotification = (actionUuid: string, output?: any): NotificationConfig => {
  return {
    type: NotificationType.SUCCESS,
    id: `${actionUuid}-scheduled`,
    message: buildOutputMessage(output),
    dataCy: 'schedule-success-notification',
  };
};
